import { isNumeric } from '80.quickConnect.Core/helpers/common';
import { DigitsDesc } from '90.quickConnect.Models/models';

const mapDigitsDesc = (field: DigitsDesc): DigitsDesc => {
  const intDefault = isNumeric(field.defaultValue) ? field.defaultValue : undefined;
  return {
    min: field.min ?? undefined,
    max: field.max ?? undefined,
    isVertical: field.isVertical,
    value: field.value?.toString() ?? intDefault,
    defaultValue: intDefault,
  } as DigitsDesc;
};

export default mapDigitsDesc;
